import Text from '@eversports/react-components/primitives/Text'
import Icon, { Icons } from '@eversports/react-components/primitives/Icon'
import { Localized } from '../../localization/react'

const SpotBookingInformation = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
    <Icon icon={Icons.INFO} size="small" color="primary.main" />
    <Text size="small">
      <Localized id="spot-booking-information" />
    </Text>
  </div>
)

export { SpotBookingInformation }
